export const PermissionValidators = {
  name: (v) => {
    const len = v?.trim()?.length || 0;
    return len < 3 ? "Name must be at least 3 characters" : null;
  },
  description: (v) => {
    const len = v?.trim()?.length || 0;
    return len < 5 ? "Description must be at least 5 characters" : null;
  },
};

export const RoleValidators = {
  name: (v) => {
    const len = v?.trim()?.length || 0;
    if (!v || len === 0) return "Role name is required";
    if (len < 3) return "Role name must be at least 3 characters";
    return null;
  },
  permissionIds: (v) => {
    if (!Array.isArray(v)) return "Permissions must be an array";
    if (v.length === 0) return "Select at least one permission";
    return null;
  },
};

export const UserValidators = {
  firstname: (v) => {
    const len = v?.trim()?.length || 0;
    return len < 3 ? "Name must be at least 3 characters" : null;
  },
  lastname: (v) => {
    const len = v?.trim()?.length || 0;
    return len < 3 ? "Name must be at least 3 characters" : null;
  },
  email: (v) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(v) ? null : "Invalid email address";
  },
  msisdn: (v) => {
    const trimmed = v.trim();

    if (!/^\d+$/.test(trimmed)) {
      return "Phone number must contain digits only";
    }

    if (!trimmed.startsWith("254")) {
      return "Phone number must start with '254'";
    }

    if (trimmed.length !== 12) {
      return "Phone number must be exactly 12 digits (e.g., 2547XXXXXXXX)";
    }
    return null;
  },
  mfaenabled: (v) => {
    if (v !== true) {
      return "MFA must always be enabled";
    }
    return null;
  },
};


